//@ts-check
import * as THREE from "three";

/**
 * @module Materials
 */

/**
 * Sets Default Materials 
 */
export function setDefaultMaterials() {
  this.setGhostMaterial();
  this.setSelectionMaterial();
  this.setHighlightMaterial();
  this.setGroundMaterial();

}

/**
 * Sets Ghost Material : scope.ghostMaterial
 * @param {Number} [color= 0xf3f3f3 ] - Hex Color
 * @param {*} [opacity = 0.2] - Opacity
 */
export function setGhostMaterial(color = 0xf3f3f3, opacity = 0.2) {
  let scope = this;

  // -------- GHOST MATERIAL --------
  scope.ghostColor = new THREE.Color(color)

  scope.ghostMaterial = new THREE.MeshBasicMaterial({
    name: "GlobalGhostedMaterial",
    visible: true,
    transparent: true,
    opacity: opacity,
    color: scope.ghostColor,
    side: THREE.DoubleSide,
    forceSinglePass: true,
  });

}

/**
  * Sets global selection material 
  * : scope.selectionMaterial per global scope.pickColor
  */
export function setSelectionMaterial() {
  let scope = this;

  // -------- SELECTION MATERIAL --------
  scope.selectionMaterial = new THREE.MeshStandardMaterial({
    name: "GlobalSelectionMaterial",
    visible: true,
    transparent: false,
    metalness: 0.01,
    roughness: 0.99,
    opacity: 1.0,
    color: scope.pickColor,
    side: THREE.DoubleSide,
    forceSinglePass: true,
  });

}

/**
  * Sets global highlight material 
  * : scope.highlightMaterial per global scope.highlightColor
  */
export function setHighlightMaterial() {
  let scope = this;

  // -------- HIGHLIGHT MATERIAL --------
  scope.highlightMaterial = new THREE.MeshStandardMaterial({
    name: "GlobalHighlightMaterial",
    visible: true,
    transparent: false,
    metalness: 0.01,
    roughness: 0.99,
    opacity: 1.0,
    color: scope.highlightColor,
    side: THREE.DoubleSide,
    forceSinglePass: true,
  });

}

/**
  * Sets global ground material 
  * : scope.groundMaterial per global scope.groundColor) and scope.groundOpacity
  */
export function setGroundMaterial() {
  let scope = this;

  // -------- GROUND MATERIAL --------
  scope.groundMaterial = new THREE.MeshStandardMaterial({
    transparent: false,
    color: this.parseColor(scope.groundColor),
    opacity: scope.groundOpacity,
    metalness: 1.0,
    roughness: 1.0,
    //receiveShadow: true
  });

}